module.exports = __webpack_public_path__ + "img/aywa.2cd912c4.svg";